__turbopack_context__.v({
  "icon": "qVLjVG_icon",
  "sizeM": "qVLjVG_sizeM",
  "sizeS": "qVLjVG_sizeS",
  "tag": "qVLjVG_tag",
  "variantDangerTinted": "qVLjVG_variantDangerTinted",
  "variantInformativeTinted": "qVLjVG_variantInformativeTinted",
  "variantNeutral": "qVLjVG_variantNeutral",
  "variantNeutralTinted": "qVLjVG_variantNeutralTinted",
  "variantPrimary": "qVLjVG_variantPrimary",
  "variantPrimaryTinted": "qVLjVG_variantPrimaryTinted",
  "variantPrimavera": "qVLjVG_variantPrimavera",
  "variantStrongTinted": "qVLjVG_variantStrongTinted",
  "variantSuccess": "qVLjVG_variantSuccess",
  "variantSuccessTinted": "qVLjVG_variantSuccessTinted",
  "variantTotally": "qVLjVG_variantTotally",
  "variantWarningTinted": "qVLjVG_variantWarningTinted",
});
